import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { auth, db } from '../settings/firebase';
import { sendnotification } from '../function/sendnotification';

const useStyles = makeStyles((theme) => ({
  following: {
    borderRadius: "20px", textDecoration: "none", textAlign: "center",
    padding: "7px", width: "9em", fontFamily: "Roboto", fontWeight: "600",
    boxShadow: "0 1px 2px #555555", backgroundColor: theme.palette.primary.main,
    color: "#222222", margin: "0em 2em 1em 0em",
    '&:hover': {
      cursor: "pointer", textDecoration: "none", border: "2px "+theme.palette.secondary.main
    }
  },
  unfollowing: {
    borderRadius: "20px", textDecoration: "none", textAlign: "center",
    padding: "7px", width: "9em", fontFamily: "Roboto", fontWeight: "600",
    boxShadow: "0 1px 2px #555555", backgroundColor: theme.palette.secondary.main,
    color: "#222222", margin: "0em 2em 1em 0em",
    '&:hover': {
      cursor: "pointer", textDecoration: "none", border: "2px "+theme.palette.primary.main
    }
  }
}))

export default function Follow(props) {
  const { followuid, style } = props;
  const [isfollowing, setisfollowing] = useState(false);
  const [islogined, setislogined] = useState(false);

  const classes = useStyles();

  auth.onAuthStateChanged(user => {
    if (user) {
      setislogined(true);
      db.collection("follows").doc(user.uid).onSnapshot(doc => {
        if (doc.exists) {
          // console.log(doc.data())
          doc.data().following.forEach(following => {
            if (following.uid === followuid) {
              setisfollowing(true);
            }
          })
        }
      })
    }
  })

  const changeFollow = () => {
    auth.onAuthStateChanged(user => {
      if (user) {
        setislogined(true);
        const followdoc = db.collection("follows").doc(user.uid);
        const followuserdoc = db.collection("users").doc(followuid);
        const followeruserdoc = db.collection("users").doc(user.uid);
        db.runTransaction((transaction) => {
          return transaction.get(followeruserdoc).then((flwerdoc) => {
            if (!flwerdoc.exists) {
              throw "Error";
            }
            transaction.get(followuserdoc).then((flwdoc) => {
              if (!flwerdoc.exists) {
                throw "Error";
              }
              followdoc.get().then((doc) => {
                if (doc.exists) {
                  let add = true;
                  let index = 0;
                  let newlist = doc.data().following;
                  for (let idx = 0; idx < newlist.length; idx++) {
                    if(newlist[idx]["uid"] === followuid) {
                      add = false;
                      index = idx;
                      break;
                    }
                  }
                  if (add) {
                    newlist.push({uid: followuid, ts: new Date()})
                    followuserdoc.update({ follower: flwdoc.data().follower+1 });
                    const newflwer = flwerdoc.data().follow + 1;
                    followeruserdoc.update({ follow: newflwer });
                    // フォローを相手に通知
                    sendnotification(flwdoc.id, flwerdoc, "follow", flwerdoc.data().name+"がフォローしました。");
                    setisfollowing(true);
                  } else {
                    newlist.splice(index, 1);
                    followuserdoc.update({ follower: flwdoc.data().follower-1 });
                    const newflwer = flwerdoc.data().follow - 1;
                    followeruserdoc.update({ follow: newflwer });
                    setisfollowing(false);
                  }
                  followdoc.update({ following: newlist });
                } else {
                  followdoc.set({ following: [{uid: followuid, ts: new Date()}]});
                }
              });
            });
          })
        })
      } else {
        setislogined(false);
      }
    })
  }

  return (
    <>
      {islogined?
        <button className={isfollowing? classes.following: classes.unfollowing} onClick={changeFollow}>{isfollowing? <>フォロー中</>: <>フォローする</>}</button>
      : null }
    </>
  )
}